// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#earnings-dashboard {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

#earnings-header {
  margin-bottom: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  width: 100%;
  min-height: 70px;
}

#earnings-header__title {
    display: flex;
    flex-wrap: nowrap;
    align-items: center;
    position: relative;
    font-size: 30px;
    font-weight: 400;
    margin-bottom: 5px;
  }

#earnings-header__subtitle {
    font-size: 18px;
    color: #475467;
    font-weight: 100;
    margin-bottom: 5px;
    margin-left: 2px;
  }

#earnings-header__right {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
  }

#earnings-section1,
#earnings-section2,
#earnings-section3,
.earnings-section {
  width: 100%;
  margin-bottom: 20px;
}

#earnings-charts-top-level-container {
  display: flex;
  width: 100%;
  padding-bottom: 0.5rem
}

@media (max-width: 1024px) {

#earnings-charts-top-level-container {
    display: block
}
  }

#earnings-charts-top-level-container #earnings-donut-chart-container {
    min-width: 300px;
    height: 250px
  }

@media (max-width: 1024px) {
  #earnings-charts-top-level-container #earnings-donut-chart-container {
      min-width: 0;
      width: 100%
  }
    }

#earnings-section0 {
  position: relative;
}

.loading-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.7);
  z-index: 1;
}

#earnings-breakdown-legend {
  display: flex
}

@media (max-width: 1024px) {

#earnings-breakdown-legend {
    display: block
}
  }

#earnings-breakdown-legend {
  width: 100%;
  margin-top: 1rem;
}

#earnings-breakdown-legend .ebl-section {
    flex-grow: 1;
    padding: 0 2rem
  }

@media (max-width: 1024px) {
  #earnings-breakdown-legend .ebl-section {
      padding: 0
  }
    }

#earnings-breakdown-legend h2,
  #earnings-breakdown-legend h3,
  #earnings-breakdown-legend h4 {
    margin: 0;
  }

#earnings-breakdown-legend h2 {
    font-size: 1.25rem;
    font-weight: 400;
    margin-bottom: 0;
  }

#earnings-breakdown-legend ul {
    list-style-type: none;
    padding: 0;
  }

#earnings-breakdown-legend ul li {
      flex-grow: 1;
      background: rgba(211, 211, 211, 0.1);
      padding: 0.5rem 0.2rem;

      margin-top: 0.5rem;
    }

#earnings-breakdown-legend ul li > div:first-child {
        display: flex;
        align-items: center;
      }

#earnings-breakdown-legend ul li > div:first-child .legend-bullet {
          width: 0.5rem;
          height: 0.5rem;
          border-radius: 50%;
          margin-right: 0.5rem;
        }

#earnings-breakdown-legend ul li > div:first-child h3 {
          margin: 0;
          font-size: 0.9rem;
          font-weight: 400
        }

@media (max-width: calc(1024px + 100px)) and (min-width: 1024px) {
        #earnings-breakdown-legend ul li > div:first-child h3 {
            font-size: 0.5rem
        }
          }

#earnings-breakdown-legend ul li > h4 {
        color: #475467;
        font-weight: 200;
        font-size: 0.9rem;
      }

#earnings-breakdown-legend ul li {
      display: flex;
      align-items: center;
      justify-content: space-between;
    }

.chart-purple {
  color: #560d84;
}
.chart-pink {
  color: #ba82de;
}
.chart-navy {
  color: #0e71bb;
}
.chart-sky {
  color: #6ccafc;
}
`, "",{"version":3,"sources":["webpack://./src/pages/Earnings.pcss"],"names":[],"mappings":"AAKA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,mBAA2B;EAC3B,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,WAAW;EACX,gBAAgB;AAsBlB;;AArBE;IACE,aAAa;IACb,iBAAiB;IACjB,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,kBAAkB;EACpB;;AACA;IACE,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;EAClB;;AACA;IACE,aAAa;IACb,mBAAmB;IACnB,eAAe;EACjB;;AAGF;;;;EAIE,WAAW;EACX,mBAA2B;AAC7B;;AAIA;EACE,aAAa;EACb,WAAW;EACX;AAYF;;AAXE;;AAJF;IAKI;AAUJ;EATE;;AACA;IACE,gBAAgB;IAChB;EAKF;;AAJE;EAHF;MAII,YAAY;MACZ;EAEJ;IADE;;AAIJ;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,UAAU;AACZ;;AAEA;EACE;AA6DF;;AA5DE;;AAFF;IAGI;AA2DJ;EA1DE;;AAJF;EAKE,WAAW;EACX,gBAAgB;AAwDlB;;AAvDE;IACE,YAAY;IACZ;EAIF;;AAHE;EAHF;MAII;EAEJ;IADE;;AAEF;;;IAGE,SAAS;EACX;;AACA;IACE,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;EAClB;;AACA;IACE,qBAAqB;IACrB,UAAU;EAmCZ;;AAjCE;MACE,YAAY;MACZ,oCAAoC;MACpC,sBAAsB;;MAEtB,kBAAkB;IA2BpB;;AA1BE;QACE,aAAa;QACb,mBAAmB;MAerB;;AAdE;UACE,aAAa;UACb,cAAc;UACd,kBAAkB;UAClB,oBAAoB;QACtB;;AACA;UACE,SAAS;UACT,iBAAiB;UACjB;QAIF;;AAHE;QAJF;YAKI;QAEJ;UADE;;AAGJ;QACE,cAAc;QACd,gBAAgB;QAChB,iBAAiB;MACnB;;AA5BF;MA6BE,aAAa;MACb,mBAAmB;MACnB,8BAA8B;IAChC;;AAIJ;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB","sourcesContent":["$verticalGap: 20px;\n$mediascreen: 990px;\n$horizontalGap: 15px;\n$gridGap: 12px;\n\n#earnings-dashboard {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n}\n\n#earnings-header {\n  margin-bottom: $verticalGap;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  flex-wrap: wrap;\n  width: 100%;\n  min-height: 70px;\n  &__title {\n    display: flex;\n    flex-wrap: nowrap;\n    align-items: center;\n    position: relative;\n    font-size: 30px;\n    font-weight: 400;\n    margin-bottom: 5px;\n  }\n  &__subtitle {\n    font-size: 18px;\n    color: #475467;\n    font-weight: 100;\n    margin-bottom: 5px;\n    margin-left: 2px;\n  }\n  &__right {\n    display: flex;\n    flex-direction: row;\n    flex-wrap: wrap;\n  }\n}\n\n#earnings-section1,\n#earnings-section2,\n#earnings-section3,\n.earnings-section {\n  width: 100%;\n  margin-bottom: $verticalGap;\n}\n\n$breakpoint: 1024px;\n\n#earnings-charts-top-level-container {\n  display: flex;\n  width: 100%;\n  padding-bottom: 0.5rem;\n  @media (max-width: $breakpoint) {\n    display: block;\n  }\n  #earnings-donut-chart-container {\n    min-width: 300px;\n    height: 250px;\n    @media (max-width: $breakpoint) {\n      min-width: 0;\n      width: 100%;\n    }\n  }\n}\n\n#earnings-section0 {\n  position: relative;\n}\n\n.loading-overlay {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: rgba(255, 255, 255, 0.7);\n  z-index: 1;\n}\n\n#earnings-breakdown-legend {\n  display: flex;\n  @media (max-width: $breakpoint) {\n    display: block;\n  }\n  width: 100%;\n  margin-top: 1rem;\n  .ebl-section {\n    flex-grow: 1;\n    padding: 0 2rem;\n    @media (max-width: $breakpoint) {\n      padding: 0;\n    }\n  }\n  h2,\n  h3,\n  h4 {\n    margin: 0;\n  }\n  h2 {\n    font-size: 1.25rem;\n    font-weight: 400;\n    margin-bottom: 0;\n  }\n  ul {\n    list-style-type: none;\n    padding: 0;\n\n    li {\n      flex-grow: 1;\n      background: rgba(211, 211, 211, 0.1);\n      padding: 0.5rem 0.2rem;\n\n      margin-top: 0.5rem;\n      & > div:first-child {\n        display: flex;\n        align-items: center;\n        .legend-bullet {\n          width: 0.5rem;\n          height: 0.5rem;\n          border-radius: 50%;\n          margin-right: 0.5rem;\n        }\n        h3 {\n          margin: 0;\n          font-size: 0.9rem;\n          font-weight: 400;\n          @media (max-width: calc($breakpoint + 100px)) and (min-width: $breakpoint) {\n            font-size: 0.5rem;\n          }\n        }\n      }\n      & > h4 {\n        color: #475467;\n        font-weight: 200;\n        font-size: 0.9rem;\n      }\n      display: flex;\n      align-items: center;\n      justify-content: space-between;\n    }\n  }\n}\n\n.chart-purple {\n  color: #560d84;\n}\n.chart-pink {\n  color: #ba82de;\n}\n.chart-navy {\n  color: #0e71bb;\n}\n.chart-sky {\n  color: #6ccafc;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
